import React from 'react';
import { OauthAuthMode } from './OauthButton';

export interface ShopifyAuthModalProps {
    mode: OauthAuthMode;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

/**
 * Store-name modal for Shopify OAuth. Must be rendered outside the login/signup
 * credential form so the nested form does not nest inside another form.
 */
const ShopifyAuthModal: React.FC<ShopifyAuthModalProps> = ({ mode, onSubmit }) => {
    const title = mode === 'signin' ? 'Sign In With Shopify' : 'Sign Up With Shopify';

    return (
        <div
            className="modal fade"
            id="shopifyAuthModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="shopifyAuthModalLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <form
                        id="shopify-signin"
                        name="shopify-signin"
                        method="POST"
                        className="form-horizontal group-border-dashed"
                        onSubmit={onSubmit}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title" id="shopifyAuthModalLabel" style={{ fontSize: '1.3rem' }}>
                                <b>{title}</b>
                            </h5>
                            <button
                                type="button"
                                className="btn-close go-back"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-4">
                            <label className="form-label ms-1">
                                Shopify Store Name{' '}
                                <span className="ab-field-required text-danger">*</span>
                            </label>
                            <div className="input-group input-group-md shopify-input-group mb-2">
                                <input
                                    className="form-control form-control-lg form-control-solid"
                                    type="text"
                                    name="shop"
                                    autoComplete="off"
                                    placeholder="Enter Store Name"
                                    required
                                />
                                <span className="input-group-text border-0">.myshopify.com</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="form-actions">
                                <button
                                    type="button"
                                    className="btn btn-outline-light me-1"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary save">
                                    Connect
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ShopifyAuthModal;
